import { faGithub, faInstagram, faLinkedin, faTwitter, faYoutube } from "@fortawesome/free-brands-svg-icons";

const footerSocialIcons = [
	{ _id: "footerIcon1", link: "https://www.instagram.com", name: "Instagram", icon: faInstagram },
	{ _id: "footerIcon2", link: "https://www.x.com", name: "Twitter", icon: faTwitter },
	{ _id: "footerIcon3", link: "https://www.youtube.com", name: "Youtube", icon: faYoutube },
	{ _id: "footerIcon4", link: "https://github.com", name: "Github", icon: faGithub },
	{ _id: "footerIcon5", link: "https://linkedin.com", name: "Linkedin", icon: faLinkedin },
];
export default footerSocialIcons;
